import { getEmptyTheme } from 'models/Theme/Theme';
import { ExtImpl } from 'models/Widget/Widget';
import i18n from 'src/i18n';

const theme = getEmptyTheme();

const ListeningTemplate = {
    id: 'cGFuZWw6NWUwZTVmYjQ4ZTZmMjcxYjA5MzI0MWNk',
    partnerId: 50400,
    clientId: 734,
    name: 'Blank',
    description: '',
    publishTier: 'ONE',
    theme,
    storyboard: {
        id: 'c3Rvcnlib2FyZDo1ZGY3ZmE4ODhlNmYyNzdkNDIzM2I4MmY=',
        name: 'Touchscreen Test',
        pageNumber: {
            enabled: false,
            color: 'white',
            size: 10,
            alignment: 'right',
            showTotal: null,
        },
        watermark: {
            panelIndex: null,
            watermarkRendered: null,
            imageUrl: null,
        },
        timePeriod: {
            key: 'last_7_days',
            duration: null,
            timeZone: 'America/Los_Angeles',
            startTime: 1575964800000,
            endTime: 1576569599999,
        },
    },
    scene: {
        id: 'c2NlbmU6NWUwZTVmYjQ4ZTZmMjcxYjA5MzI0MWNj',
        name: 'Listening',
        duration: 0,
        disabled: false,
        theme: null,
        sceneTransition: null,
    },
    widget: {
        children: [
            {
                type: 'metric',
                id: 'drilldown_single_metric',
                name: 'Single Metric',
                position: {
                    top: null,
                    left: null,
                    height: null,
                    width: null,
                    grid: {
                        enabled: true,
                        columns: {
                            start: 0,
                            end: 2,
                        },
                        rows: {
                            start: 0,
                            end: 1,
                        },
                    },
                },
                useGlobalTimePeriod: true,
                analyticsRequests: [
                    {
                        reportingEngine: 'LISTENING',
                        projections: [],
                        report: 'SPRINKSIGHTS',
                        limit: 1,
                        groupBys: [],
                        sorts: [],
                        timePeriods: [
                            {
                                key: 'last_7_days',
                                duration: null,
                                timeZone: 'America/Los_Angeles',
                                startTime: 1575964800000,
                                endTime: 1576569599999,
                            },
                        ],
                        filters: [],
                    },
                ],
                label: {
                    titleText: 'Mentions',
                    overlap: true,
                    size: 15,
                    enabled: true,
                },
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    labelTimeZone: '',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: true,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 19,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {},
                    postVersion: 1,
                    zeroFill: false,
                    zeroKill: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: false,
                    showMetricName: false,
                    metricNameSize: 5,
                    metricNameCase: 'lowercase',
                    showMetricValue: true,
                    metricValueSize: 10,
                    metricValueFormat: '1.23k',
                    metricValueType: 'primary',
                    showMetricChange: false,
                    metricPercentChangeSize: 6,
                    highlightPercentChange: false,
                    showMetricPreviousValue: false,
                    metricPreviousValueSize: 8,
                    previousValueFormat: '1k',
                    showTimeRemainder: true,
                    thresholds: [],
                    thresholdsEnabled: false,
                    thresholdBarHeight: 2,
                    thresholdBarLength: 50,
                    thresholdsPercent: false,
                    maxThresholds: 1,
                    percentChangeColor: {
                        enabled: false,
                        up: '#33CC99',
                        zero: '',
                        down: '#FF6060',
                    },
                    showBackgroundCircle: false,
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xs',
                        baseline: {
                            metricValueSize: 60,
                            metricNameSize: 15,
                            metricPercentChangeSize: 20,
                        },
                        optionDefaults: {
                            showBackgroundCircle: true,
                        },
                        breakpoints: {
                            xs: {
                                options: {
                                    showBackgroundCircle: false,
                                },
                            },
                            s: {
                                options: {
                                    showBackgroundCircle: false,
                                },
                            },
                            m: {
                                options: {
                                    showBackgroundCircle: false,
                                },
                            },
                            l: {
                                options: {
                                    showBackgroundCircle: false,
                                },
                            },
                        },
                    },
                    primaryClasses: 'middle right',
                    portrait: {
                        widgetOrientation: 'portrait',
                        metricValueSize: 45,
                    },
                },
            },
            {
                children: null,
                id: 'drilldown_top_profiles',
                name: 'Profile',
                type: 'profile',
                useGlobalTimePeriod: true,
                css: null,
                js: null,
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    labelTimeZone: '',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: false,
                    animationVariation: 6,
                    widgetOrientation: 'portrait',
                    opacity: 100,
                    zIndex: 6,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {
                        profileInfo: 'p-05',
                        profileMetrics: 'p-05',
                        profileOuter: 'middle',
                        profileDescription: 'mt-05',
                    },
                    postVersion: 1,
                    zeroFill: false,
                    zeroKill: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: false,
                    labelSize: 6,
                    showMetricName: true,
                    metricNameSize: 7,
                    showMetricValue: true,
                    metricValueSize: 12,
                    metricValueFormat: '1.23k',
                    showMetricChange: true,
                    metricPercentChangeSize: 6,
                    showUserGroup: true,
                    showUserAvatar: true,
                    showUserName: true,
                    showUserScreenName: true,
                    rank: {
                        enabled: false,
                        size: 6,
                    },
                    userGroupIconSize: 2,
                    userGroupAvatarSize: 10,
                    userGroupNameSize: 8,
                    userGroupScreenNameSize: 8,
                    showProfileDescription: true,
                    profileDescriptionSize: 6,
                    clamp: {
                        enabled: false,
                        lines: 3,
                    },
                    showTimeStamp: false,
                    timeStampSize: 5,
                    timeStampFormat: 'timeAgo',
                    endianTime: 'D MMM YYYY, h:mm a',
                    socialIconBgColor: true,
                    smartSize: {
                        enabled: false,
                        mode: 'responsive',
                        size: 'xs',
                        baseline: {
                            metricPercentChangeSize: 20,
                            metricValueSize: 50,
                            metricNameSize: 15,
                            timeStampSize: 15,
                            labelSize: 20,
                            userGroupIconSize: 10,
                            userGroupAvatarSize: 70,
                            userGroupNameSize: 14,
                            userGroupScreenNameSize: 10,
                            profileDescriptionSize: 19,
                            rank: {
                                size: 20,
                            },
                        },
                        optionDefaults: {
                            clamp: {
                                lines: 5,
                                enabled: true,
                            },
                            classOverrides: {
                                profileInfo: 'p-1 pl-2',
                                profileMetrics: 'pb-1 pt-2',
                                profileDescription: 'mt-1',
                            },
                        },
                        breakpoints: {
                            xs: {
                                options: {
                                    clamp: {
                                        lines: 3,
                                        enabled: true,
                                    },
                                    classOverrides: {
                                        profileInfo: 'p-05',
                                        profileMetrics: 'p-05',
                                        profileDescription: 'mt-05',
                                    },
                                },
                            },
                            s: {
                                options: {
                                    clamp: {
                                        lines: 3,
                                        enabled: true,
                                    },
                                    classOverrides: {
                                        profileInfo: 'p-05',
                                        profileMetrics: 'p-05',
                                        profileDescription: 'mt-05',
                                    },
                                },
                            },
                            m: {
                                options: {
                                    clamp: {
                                        lines: 4,
                                        enabled: true,
                                    },
                                    classOverrides: {
                                        profileInfo: 'p-05 pl-1',
                                        profileMetrics: 'pb-05 pt-1',
                                        profileDescription: 'mt-05',
                                    },
                                },
                            },
                            ml: {
                                options: {
                                    clamp: {
                                        lines: 4,
                                        enabled: true,
                                    },
                                },
                            },
                        },
                    },
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                    numbProfiles: 3,
                    showDescription: true,
                    showIcon: true,
                    userGroupLayoutType: 'a',
                    showIconInUserGroup: true,
                },
                userAssetContentUrl: null,
                postRequests: null,
                classes: null,
                theme,
                position: {
                    top: null,
                    left: null,
                    height: null,
                    width: null,
                    grid: {
                        enabled: true,
                        columns: {
                            start: 8,
                            end: 12,
                        },
                        rows: {
                            start: 0,
                            end: 2,
                        },
                    },
                },
                analyticsRequests: null,
                analyticsResults: null,
                profileRequests: [
                    {
                        reportingEngine: 'LISTENING',
                        report: 'SPRINKSIGHTS',
                        page: 0,
                        pageSize: 10,
                        groupBys: [
                            {
                                dimensionName: 'PROLIFIC_USERS',
                                heading: 'Top Prolific Users',
                                groupType: 'FIELD',
                                details: {
                                    displayName: 'Top Prolific Users',
                                },
                            },
                        ],
                        sorts: [
                            {
                                heading: 'MENTIONS_COUNT',
                                order: 'DESC',
                                isDimension: false,
                            },
                        ],
                        timePeriod: {
                            key: 'last_7_days',
                            duration: null,
                            timeZone: 'America/Los_Angeles',
                            startTime: 1575964800000,
                            endTime: 1576569599999,
                        },
                        filters: [],
                    },
                ],
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: i18n.t('Prolific Users'),
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: true,
                    size: 14,
                },
            },
            {
                children: null,
                id: 'drilldown_top_posts',
                name: 'Grid',
                type: 'postsGrid',
                useGlobalTimePeriod: true,
                css: null,
                js: null,
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    labelTimeZone: '',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: false,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 8,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {
                        postInner: {
                            default: 'between',
                            review: '',
                        },
                        postText: {
                            default: 'p-reset pl-05 pr-05 pt-05 pb-05 ta-c',
                            review: 'p-reset pl-05 pr-05 pt-05 pb-05 h-50',
                        },
                        userGroup: {
                            default: 'p-reset p-05',
                            review: 'p-reset pl-05 w-a',
                        },
                        metaGroup: {
                            default: 'p-reset pt-05 pl-05 pr-05 pb-0',
                        },
                        reviewDomain: {
                            default: 'mr-05',
                        },
                        reviewRating: {
                            default: 'pl-05 pb-05 pt-05',
                        },
                        engagementMetric: {
                            default: 'm-reset ml-05',
                        },
                    },
                    postVersion: 2,
                    zeroFill: false,
                    zeroKill: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: true,
                    showImageStyles: true,
                    imageFiltersOpen: true,
                    imageFilterBlur: false,
                    imageFilterBrightness: false,
                    imageFilterContrast: false,
                    imageFilterGrayscale: false,
                    imageFilterSaturate: false,
                    imageFilterHueRotate: false,
                    imageFilterOpacity: false,
                    imageFilterInvert: false,
                    imageFilterSepia: false,
                    imageFilterBlurValue: 0,
                    imageFilterBrightnessValue: 100,
                    imageFilterContrastValue: 100,
                    imageFilterGrayscaleValue: 0,
                    imageFilterSaturateValue: 100,
                    imageFilterHueRotateValue: 0,
                    imageFilterOpacityValue: 100,
                    imageFilterInvertValue: 0,
                    imageFilterSepiaValue: 0,
                    imageBlendMode: null,
                    imageSecondaryBlendMode: '',
                    imageBlendColor: 'rgba(0,0,0,.0)',
                    imageSecondaryBlendColor: '',
                    presetImageFilters: 'none',
                    imageTextColor: '#FFF',
                    postImageTextSize: 7,
                    imagePostLineClamp: true,
                    imagePostLineClampValue: 4,
                    imagePostHideText: true,
                    imageFaceDetection: false,
                    hashtagTextColor: '',
                    hashtagBackgroundColor: '',
                    mentionTextColor: '',
                    mentionBackgroundColor: '',
                    urlTextColor: '',
                    urlBackgroundColor: '',
                    showTextEntityUrls: false,
                    showEngagementMetrics: true,
                    engagementMetricsSize: 7,
                    engagementMetricsPosition: 'bottom_left',
                    adsMetricsSize: 30,
                    showTextStyles: false,
                    showText: true,
                    textOnlyColor: '#FFF',
                    postTextOnlySize: 7,
                    postLineClamp: true,
                    postLineClampValue: 4,
                    textFitMin: 20,
                    showPostTextOverlay: false,
                    showUserGroup: true,
                    showUserAvatar: true,
                    showUserName: true,
                    showUserScreenName: true,
                    userGroupIconSize: 4,
                    userGroupAvatarSize: 12,
                    userGroupNameSize: 6,
                    userGroupScreenNameSize: 4,
                    userGroupPosition: 'bottom',
                    userGroupGradientColor: 'rgba(0,0,0,.3)',
                    userGroupGradientEnabled: false,
                    userGroupGradientDirection: 'bottomToTop',
                    showTimeStamp: false,
                    timeStampSize: 15,
                    timeStampFormat: 'timeAgo',
                    endianTime: 'D MMM YYYY, h:mm a',
                    textOnlyBackgroundColor: '',
                    textOnlyTextFormat: 'clamp',
                    textOnlyTeleprompterSpeed: 50,
                    postImageTextFormat: 'clamp',
                    postImageTeleprompterSpeed: 50,
                    imageBackgroundSize: 'cover',
                    showZeroEngagementValues: false,
                    maxCharacters: 180,
                    teleprompterSpeed: 50,
                    userGroupLayoutType: 'd',
                    postCompositionType: 'a',
                    socialIconBgColor: true,
                    customFields: {
                        fieldId: '',
                        size: 12,
                    },
                    reviews: {
                        enabled: false,
                        title: {
                            enabled: true,
                            color: '',
                            size: 17,
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 2,
                                },
                                fit: {
                                    min: 10,
                                    max: 400,
                                },
                            },
                        },
                        rating: {
                            enabled: true,
                            filledColor: '',
                            emptyColor: '',
                            size: 12,
                        },
                        product: {
                            enabled: true,
                            color: '',
                            size: 9,
                        },
                        message: {
                            enabled: true,
                            size: 13,
                            color: '',
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 5,
                                },
                                fit: {
                                    min: 20,
                                    max: 400,
                                },
                            },
                        },
                        domain: {
                            enabled: true,
                            color: '',
                            size: 9,
                        },
                    },
                    smartSize: {
                        enabled: false,
                        mode: 'responsive',
                        size: 's',
                    },
                    postComposition: 'a',
                    extraPostDataOptions: {
                        enabled: null,
                        color: '',
                        size: 15,
                        value: {
                            format: '1.23k',
                        },
                        border: {
                            enabled: true,
                            color: '',
                        },
                        header: {
                            enabled: false,
                            size: 30,
                            text: '',
                            color: '',
                        },
                    },
                    nativeStyling: {
                        enabled: true,
                        colorMode: 'light',
                        lineClamp: {
                            enabled: true,
                            lines: 5,
                            hasMedia: {
                                enabled: true,
                                lines: 1,
                            },
                        },
                        maxCharacters: 400,
                        border: {
                            enabled: false,
                            color: 'rgba(0,0,0, .3)',
                            size: 5,
                        },
                        shadow: {
                            enabled: false,
                            color: 'rgba(0,0,0, .5)',
                            size: 25,
                        },
                        fontScale: 16,
                    },
                    showSentiment: true,
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                    postTemplate: '',
                    userGroupEffect: 'top',
                    theme: 'primary',
                    showIconInUserGroup: false,
                    smartSizeCompositions: {
                        baseline: {
                            postTextOnlySize: 17,
                            postImageTextSize: 17,
                            engagementMetricsSize: 20,
                            userGroupIconSize: 14,
                            userGroupAvatarSize: 20,
                            userGroupNameSize: 14,
                            userGroupScreenNameSize: 11,
                            nativeStyling: {
                                fontScale: 40,
                            },
                        },
                        optionDefaults: {
                            optionDefaults: {
                                imagePostLineClampValue: 5,
                                postLineClampValue: 5,
                            },
                            classOverrides: {
                                postInner: {
                                    default: 'between',
                                    review: '',
                                },
                                postText: {
                                    default: 'p-reset pl-15 pr-15 pt-15 pb-05 ta-c',
                                    review: 'p-reset pl-2 pr-2 pt-05 pb-05 h-50',
                                },
                                userGroup: {
                                    default: 'p-reset p-15',
                                    review: 'p-reset pl-2 w-a',
                                },
                                metaGroup: {
                                    default: 'p-reset pt-15 pl-15 pr-15 pb-0',
                                },
                                reviewDomain: {
                                    default: 'mr-2',
                                },
                                reviewRating: {
                                    default: 'pl-2 pb-2 pt-2',
                                },
                            },
                        },
                        breakpoints: {
                            m: {
                                options: {
                                    classOverrides: {
                                        postInner: {
                                            default: 'between',
                                            review: '',
                                        },
                                        postText: {
                                            default: 'p-reset pl-1 pr-1 pt-1 pb-05 ta-c',
                                            review: 'p-reset pl-1 pr-1 pt-05 pb-05 h-50',
                                        },
                                        userGroup: {
                                            default: 'p-reset p-1',
                                            review: 'p-reset pl-1 w-a',
                                        },
                                        metaGroup: {
                                            default: 'p-reset pt-1 pl-1 pr-1 pb-0',
                                        },
                                        reviewDomain: {
                                            default: 'mr-1',
                                        },
                                        reviewRating: {
                                            default: 'pl-1 pb-1 pt-1',
                                        },
                                        engagementMetric: {
                                            default: 'm-reset ml-1',
                                        },
                                    },
                                },
                            },
                            s: {
                                options: {
                                    imagePostLineClampValue: 4,
                                    postLineClampValue: 4,
                                    classOverrides: {
                                        postInner: {
                                            default: 'between',
                                            review: '',
                                        },
                                        postText: {
                                            default: 'p-reset pl-05 pr-05 pt-05 pb-05 ta-c',
                                            review: 'p-reset pl-05 pr-05 pt-05 pb-05 h-50',
                                        },
                                        userGroup: {
                                            default: 'p-reset p-05',
                                            review: 'p-reset pl-05 w-a',
                                        },
                                        metaGroup: {
                                            default: 'p-reset pt-05 pl-05 pr-05 pb-0',
                                        },
                                        reviewDomain: {
                                            default: 'mr-05',
                                        },
                                        reviewRating: {
                                            default: 'pl-05 pb-05 pt-05',
                                        },
                                        engagementMetric: {
                                            default: 'm-reset ml-05',
                                        },
                                    },
                                },
                            },
                            xs: {
                                options: {
                                    imagePostLineClampValue: 4,
                                    postLineClampValue: 4,
                                    classOverrides: {
                                        postInner: {
                                            default: 'between',
                                            review: '',
                                        },
                                        postText: {
                                            default: 'p-reset pl-05 pr-05 pt-05 pb-05 ta-c',
                                            review: 'p-reset pl-05 pr-05 pt-05 pb-05 h-50',
                                        },
                                        userGroup: {
                                            default: 'p-reset p-05',
                                            review: 'p-reset pl-05 w-a',
                                        },
                                        metaGroup: {
                                            default: 'p-reset pt-05 pl-05 pr-05 pb-0',
                                        },
                                        reviewDomain: {
                                            default: 'mr-05',
                                        },
                                        reviewRating: {
                                            default: 'pl-05 pb-05 pt-05',
                                        },
                                        engagementMetric: {
                                            default: 'm-reset ml-05',
                                        },
                                    },
                                },
                            },
                        },
                    },
                    optionDefaults: {
                        imagePostLineClampValue: 5,
                        postLineClampValue: 5,
                    },
                },
                userAssetContentUrl: null,
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                id: {
                                    columnType: null,
                                    columnId: null,
                                    reportingEngine: 'LISTENING',
                                    report: 'SPRINKSIGHTS',
                                    projections: [],
                                    sorts: [],
                                    filters: [],
                                    timePeriods: [
                                        {
                                            key: 'last_7_days',
                                            duration: null,
                                            timeZone: 'America/Los_Angeles',
                                            startTime: 1575964800000,
                                            endTime: 1576569599999,
                                        },
                                    ],
                                    source: 'REPORTING',
                                    pageSize: 6,
                                    timePeriod: {
                                        key: 'last_7_days',
                                        duration: null,
                                        timeZone: 'America/Los_Angeles',
                                        startTime: 1575964800000,
                                        endTime: 1576569599999,
                                    },
                                    groupBys: [],
                                    showInReplyToPost: false,
                                },
                                options: {
                                    count: 5,
                                    imagePreload: true,
                                    removeDuplicates: true,
                                    shufflePosts: false,
                                    includeFaceDetection: false,
                                },
                            },
                        ],
                        format: {
                            type: 'buckets',
                            options: {
                                padding: 1,
                                buckets: {
                                    any: {
                                        filter: 'post.type',
                                    },
                                },
                                panels: [
                                    {
                                        total: 3,
                                        buckets: ['any', -1],
                                    },
                                ],
                                ordered: true,
                            },
                        },
                        showInReplyToPost: false,
                    },
                ],
                classes: null,
                theme,
                position: {
                    top: null,
                    left: null,
                    height: null,
                    width: null,
                    grid: {
                        enabled: true,
                        columns: {
                            start: 0,
                            end: 8,
                        },
                        rows: {
                            start: 3,
                            end: 6,
                        },
                    },
                },
                analyticsRequests: null,
                analyticsResults: null,
                profileRequests: null,
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: i18n.t('Top Posts'),
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: true,
                    size: 13.5,
                },
            },
            {
                children: null,
                id: 'drilldown_trend_over_time',
                name: 'Trend Over Time',
                type: 'barChart',
                useGlobalTimePeriod: false,
                css: null,
                js: null,
                options: {
                    animationDelay: 0,
                    animationEnabled: true,
                    animationLength: 1000,
                    animationType: 'fade',
                    animationVariation: 6,
                    autoSizeWords: false,
                    barChartScale: 100,
                    blacklist: [],
                    borderRadius: 0,
                    borderRadiusEnd: 0,
                    borderRadiusMode: 'all',
                    borderRadiusStart: 0,
                    centerAxis: {
                        color: '',
                        enabled: true,
                        size: 10,
                        spacing: 15,
                    },
                    classOverrides: {},
                    colorFont: null,
                    cumulative: false,
                    deprecated: {
                        labelEnable: true,
                    },
                    endianTime: 'MMM DD',
                    fontFamilyPrimary: null,
                    fontFamilySecondary: null,
                    fontSize: null,
                    highlightPercentChange: false,
                    includeQuoteTweets: false,
                    invertDataSet: false,
                    labelEnable: false,
                    labelLineClamp: true,
                    labelLineClampValue: 1,
                    labelSize: 25,
                    labelTextFormat: 'clamp',
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    labelTimeRangeSize: 16,
                    labelTimeZone: '',
                    labelWrapText: false,
                    locked: false,
                    maxThresholds: 5,
                    metricNameCase: 'lowercase',
                    metricNameSize: 9,
                    metricPercentChangeSize: 10,
                    metricThreshold: null,
                    metricTimeRoundSeconds: false,
                    metricValueCase: 'lowercase',
                    metricValueCountup: {
                        duration: 30,
                        enabled: true,
                    },
                    metricValueFormat: '1.23k',
                    metricValueSize: 45,
                    opacity: 100,
                    orientation: 'horizontal',
                    padding: 13,
                    percentChangeColor: {
                        down: '#FF6060',
                        enabled: false,
                        up: '#33CC99',
                        zero: '',
                    },
                    percentChangeFormat: '1k',
                    player: {
                        duration: 15,
                        playing: false,
                    },
                    portrait: {
                        labelSize: 20,
                        limit: 3,
                        metricNameSize: 15,
                        widgetOrientation: 'portrait',
                    },
                    postVersion: 1,
                    requestSort: true,
                    showAccountIcon: false,
                    showAdsMetrics: false,
                    showFullTimePeriod: false,
                    showMetricChange: false,
                    showMetricName: false,
                    showMetricValue: false,
                    showPostTextOverlayAsGradient: false,
                    showSentiment: false,
                    showSocialColors: true,
                    showTimeRemainder: false,
                    showYAxis: false,
                    smartSize: {
                        baseline: {
                            labelSize: 25,
                            metricNameSize: 15,
                            metricPercentChangeSize: 17,
                            metricValueSize: 50,
                            padding: 21,
                            spacing: 6,
                        },
                        breakpoints: {
                            m: {
                                options: {
                                    showMetricChange: false,
                                    showTimeRemainder: false,
                                },
                            },
                            s: {
                                options: {
                                    showMetricChange: false,
                                    showMetricName: false,
                                    showTimeRemainder: false,
                                },
                            },
                            xs: {
                                options: {
                                    labelEnable: false,
                                    showMetricChange: false,
                                    showMetricName: false,
                                    showMetricValue: false,
                                    showTimeRemainder: false,
                                },
                            },
                        },
                        enabled: false,
                        mode: 'responsive',
                        optionDefaults: {
                            labelEnable: true,
                            showMetricChange: true,
                            showMetricName: true,
                            showMetricValue: true,
                            showTimeRemainder: true,
                        },
                        size: 'm',
                    },
                    sort: 'none',
                    sortDirection: 'DESC',
                    sortHeading: 'none',
                    spacing: 4,
                    stacked100Percent: false,
                    stackedInline: false,
                    textFormat: '',
                    themeEmailSize: 20,
                    themeImageCircleMask: true,
                    themeImageOpacity: 100,
                    themeImagePosition: null,
                    themeImageSize: 100,
                    thresholdLineWidth: 0.5,
                    thresholds: [],
                    thresholdsAxis: true,
                    thresholdsDashed: false,
                    thresholdsEnabled: false,
                    thresholdsLegend: false,
                    thresholdsPercent: false,
                    thresholdsStacked: false,
                    useThemeColor: false,
                    useThemeEmail: false,
                    useThemeImage: false,
                    widgetOrientation: 'landscape',
                    xAxis: {
                        enabled: true,
                        label: {
                            enabled: false,
                            padding: 20,
                            size: 50,
                        },
                        ticks: {
                            enabled: true,
                            label: {
                                angle: 0,
                                enabled: true,
                                numberCase: 'lowercase',
                                numberFormat: '1.2k',
                                size: 50,
                                timeFormat: 'dddd',
                            },
                            line: {
                                enabled: false,
                            },
                            numTicks: 24,
                        },
                    },
                    yAxis: {
                        enabled: true,
                        label: {
                            enabled: false,
                            padding: 0,
                            size: 0,
                        },
                        ticks: {
                            enabled: true,
                            label: {
                                angle: 0,
                                enabled: true,
                                numberCase: 'lowercase',
                                numberFormat: '1.2k',
                                size: 50,
                                timeFormat: 'ddd ha',
                            },
                            line: {
                                enabled: false,
                            },
                            numTicks: 4,
                        },
                    },
                    yAxisLabelSize: 24,
                    zeroFill: true,
                    zeroKill: false,
                    zIndex: 19,
                },
                userAssetContentUrl: null,
                postRequests: null,
                classes: null,
                theme,
                position: {
                    top: null,
                    left: null,
                    height: null,
                    width: null,
                    grid: {
                        enabled: true,
                        columns: {
                            start: 0,
                            end: 8,
                        },
                        rows: {
                            start: 1,
                            end: 3,
                        },
                    },
                },
                analyticsRequests: [
                    {
                        timeField: null,
                        includeTotal: null,
                        additional: {
                            TARGET_LANG_CODE: null,
                            Currency: null,
                            slaConfig: null,
                        },
                        reportingEngine: 'LISTENING',
                        report: 'SPRINKSIGHTS',
                        limit: 100,
                        sorts: [
                            {
                                order: 'ASC',
                                heading: 'Created Time_1d',
                            },
                        ],
                        timePeriods: [
                            {
                                duration: 86400000,
                                startTime: 1579248000000,
                                endTime: 1579852799999,
                                timeZone: 'America/Los_Angeles',
                                key: 'last_7_days',
                                previousPeriod: false,
                                wholePeriods: false,
                                xValue: null,
                            },
                        ],
                        groupBys: [
                            {
                                heading: 'Created Time_1d',
                                dimensionName: 'SN_CREATED_TIME',
                                groupType: 'DATE_HISTOGRAM',
                                details: {
                                    interval: '1d',
                                },
                            },
                        ],
                        filters: [],
                        projections: [],
                    },
                ],
                analyticsResults: null,
                profileRequests: null,
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: 'Total Mentions',
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: false,
                    size: 10,
                },
            },
            {
                children: null,
                type: 'rankedTable',
                id: 'drilldown_top_domains',
                name: 'Top Domains',
                useGlobalTimePeriod: true,
                useGlobalTranslate: true,
                translationLanguage: null,
                analyticsRequests: [
                    {
                        reportingEngine: 'LISTENING',
                        report: 'SPRINKSIGHTS',
                        limit: 3,
                        projections: [
                            {
                                heading: 'Mentions',
                                measurementName: 'MENTIONS_COUNT',
                                aggregateFunction: 'SUM',
                                details: {
                                    alternateHeading: null,
                                    lookupId: 'M_SPRINKSIGHTS_MENTIONS_COUNT',
                                },
                            },
                            {
                                heading: 'WEB_REACH_COUNT',
                                measurementName: 'WEB_REACH_COUNT',
                                aggregateFunction: 'SUM',
                                details: {
                                    alternateHeading: null,
                                    lookupId: 'M_SPRINKSIGHTS_WEB_REACH_COUNT',
                                    origReport: 'SPRINKSIGHTS',
                                    label: 'Media Reach',
                                },
                            },
                        ],
                        groupBys: [
                            {
                                heading: 'Domain',
                                dimensionName: 'DOMAINS',
                                groupType: 'FIELD',
                                details: {
                                    displayName: 'Domain',
                                    dataType: 'STRING',
                                },
                                limit: 0,
                                limitType: 'NONE',
                                namedFilters: null,
                            },
                        ],
                        sorts: [
                            {
                                order: 'DESC',
                                heading: 'Mentions',
                            },
                        ],
                        timePeriods: [
                            {
                                key: 'last_7_days',
                                duration: null,
                                timeZone: 'America/Los_Angeles',
                                startTime: 1575964800000,
                                endTime: 1576569599999,
                            },
                        ],
                        additional: {
                            TARGET_LANG_CODE: null,
                            Currency: null,
                            slaConfig: null,
                        },
                        filters: [],
                        includeTotal: null,
                        timeField: null,
                        viralTrends: [],
                    },
                ],
                position: {
                    top: null,
                    left: null,
                    height: null,
                    width: null,
                    grid: {
                        enabled: true,
                        columns: {
                            start: 8,
                            end: 12,
                        },
                        rows: {
                            start: 2,
                            end: 4,
                        },
                    },
                },
                label: {
                    titleText: i18n.t('Top Domains'),
                    enabled: true,
                    size: 14,
                    textShadow: {
                        enabled: false,
                        color: 'rgba(0,0,0,.3)',
                        x: 1,
                        y: 1,
                        blur: 2,
                    },
                },
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                        waitVideoEnd: false,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    labelTimeZone: '',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: true,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 0,
                    locked: false,
                    sort: 'metric',
                    sortDirection: 'DESC',
                    sortHeading: 'WEB_REACH_COUNT',
                    requestSort: true,
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {},
                    postVersion: 1,
                    zeroFill: false,
                    zeroKill: false,
                    cumulative: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: false,
                    enabledSocialColorOverrides: false,
                    metricValueCountup: {
                        enabled: false,
                        duration: 30,
                    },
                    showAccountIcon: true,
                    includeQuoteTweets: false,
                    languageDirection: 'auto',
                    labelSize: 20,
                    labelName: 'Row Name',
                    showRowSize: true,
                    rowSize: 15,
                    showColumnName: false,
                    columnNameSize: 6,
                    columnNameFormat: 'auto',
                    dimensionSize: 13,
                    alignment: {
                        rowName: 'left',
                        columnName: 'left',
                        metric: 'right',
                    },
                    showMetricName: true,
                    metricNameSize: 10,
                    metricNameCase: 'lowercase',
                    metricValueFormat: '1k',
                    metricValueCase: 'lowercase',
                    showMetricValue: true,
                    metricValueSize: 24,
                    showMetricChange: false,
                    metricPercentChangeSize: 16,
                    highlightPercentChange: false,
                    rowNumbers: false,
                    showTimeRemainder: true,
                    orientation: 'vertical',
                    autoRowHeight: false,
                    smartSize: {
                        enabled: false,
                        mode: 'responsive',
                        size: 'xl',
                        baseline: {
                            labelSize: 20,
                            metricNameSize: 13,
                            columnNameSize: 20,
                            dimensionSize: 15,
                            metricValueSize: 50,
                            metricPercentChangeSize: 16,
                        },
                        optionDefaults: {},
                        breakpoints: {},
                    },
                    legacyMode: false,
                    borders: {
                        cell: {
                            enabled: true,
                            size: 0,
                            color: '',
                        },
                        top: {
                            enabled: false,
                            size: 20,
                            color: '',
                        },
                        bottom: {
                            enabled: false,
                            size: 20,
                            color: '',
                        },
                    },
                    expandedTextCell: {
                        enabled: false,
                        characterThreshold: 30,
                        lineClamp: {
                            enabled: true,
                            lines: 3,
                        },
                    },
                    percentChangeColor: {
                        enabled: true,
                        up: '#33CC99',
                        zero: '',
                        down: '#FF6060',
                    },
                },
                globalDataSourceName: null,
                useGlobalDataSources: false,
                theme,
                userAssetId: null,
                userAssetContentUrl: null,
                classes: null,
                css: null,
                js: null,
                postRequests: null,
                profileRequests: null,
                trendRequests: null,
                useGlobalPreviousTimePeriod: null,
                analyticsResults: null,
            },
            {
                type: 'barChart',
                id: 'drilldown_top_countries_cities',
                name: 'Top Countries/Cities',
                useGlobalTimePeriod: true,
                useGlobalTranslate: true,
                translationLanguage: null,
                analyticsRequests: [
                    {
                        reportingEngine: 'LISTENING',
                        projections: [
                            {
                                heading: 'Mentions',
                                measurementName: 'MENTIONS_COUNT',
                                aggregateFunction: 'SUM',
                                details: {
                                    lookupId: 'M_SPRINKSIGHTS_MENTIONS_COUNT',
                                },
                            },
                        ],
                        report: 'SPRINKSIGHTS',
                        limit: 3,
                        groupBys: [
                            {
                                heading: 'Country',
                                dimensionName: 'COUNTRY',
                                groupType: 'FIELD',
                                details: {
                                    displayName: 'Country',
                                    dataType: 'PICKLIST',
                                },
                                limit: 0,
                                limitType: 'NONE',
                                namedFilters: null,
                            },
                        ],
                        sorts: [
                            {
                                order: 'DESC',
                                heading: 'Mentions',
                            },
                            {
                                order: 'ASC',
                                heading: 'Country',
                            },
                        ],
                        timePeriods: [
                            {
                                key: 'last_7_days',
                                duration: null,
                                timeZone: 'America/Los_Angeles',
                                startTime: 1575964800000,
                                endTime: 1576569599999,
                            },
                        ],
                        filters: [],
                        includeTotal: null,
                        timeField: null,
                        viralTrends: [],
                        additional: null,
                    },
                ],
                position: {
                    top: '0px',
                    left: '0px',
                    height: '0px',
                    width: '0px',
                    grid: {
                        enabled: true,
                        columns: {
                            start: '8',
                            end: '12',
                        },
                        rows: {
                            start: '4',
                            end: '6',
                        },
                    },
                    right: null,
                    bottom: null,
                    portrait: null,
                    landscape: null,
                    backgroundColor: null,
                    display: null,
                    maxWidth: null,
                    maxHeight: null,
                },
                label: {
                    titleText: i18n.t('Top Countries / Cities'),
                    enabled: true,
                    size: 14,
                    textShadow: {
                        enabled: false,
                        color: 'rgba(0,0,0,.3)',
                        x: 1,
                        y: 1,
                        blur: 2,
                    },
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                },
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                        waitVideoEnd: false,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    labelTimeZone: '',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: true,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 1,
                    locked: false,
                    sort: 'auto',
                    sortDirection: 'DESC',
                    sortHeading: '',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: 'left',
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {},
                    postVersion: 1,
                    zeroFill: true,
                    zeroKill: false,
                    cumulative: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: false,
                    enabledSocialColorOverrides: false,
                    metricValueCountup: {
                        enabled: true,
                        duration: 30,
                    },
                    showAccountIcon: false,
                    includeQuoteTweets: false,
                    labelSize: 12,
                    deprecated: {
                        labelEnable: false,
                    },
                    showYAxis: false,
                    yAxisLabelSize: 24,
                    xAxis: {
                        enabled: false,
                        label: {
                            enabled: true,
                            size: 50,
                            padding: 20,
                        },
                        ticks: {
                            enabled: true,
                            label: {
                                enabled: false,
                                size: 50,
                                numberFormat: '1.2k',
                                numberCase: 'lowercase',
                                timeFormat: 'ddd ha',
                                angle: 0,
                            },
                            line: {
                                enabled: true,
                            },
                            numTicks: 10,
                        },
                    },
                    yAxis: {
                        enabled: false,
                        label: {
                            enabled: true,
                            size: 50,
                            padding: 20,
                        },
                        ticks: {
                            enabled: true,
                            label: {
                                enabled: false,
                                size: 50,
                                numberFormat: '1.2k',
                                numberCase: 'lowercase',
                                timeFormat: 'ddd ha',
                                angle: 0,
                            },
                            line: {
                                enabled: false,
                            },
                            numTicks: 10,
                        },
                    },
                    showMetricName: false,
                    metricNameSize: 9,
                    metricNameCase: 'lowercase',
                    showMetricValue: true,
                    metricValueSize: 12,
                    metricValueFormat: '1k',
                    metricValueCase: 'lowercase',
                    showMetricChange: false,
                    metricPercentChangeSize: 10,
                    highlightPercentChange: false,
                    stacked100Percent: false,
                    stackedInline: false,
                    showTimeRemainder: false,
                    spacing: 4,
                    padding: 4,
                    borderRadiusMode: 'all',
                    borderRadius: 0,
                    borderRadiusStart: 0,
                    borderRadiusEnd: 0,
                    thresholds: [],
                    thresholdsEnabled: false,
                    thresholdsLegend: false,
                    thresholdsStacked: false,
                    thresholdLineWidth: 0.5,
                    thresholdsPercent: false,
                    thresholdsAxis: true,
                    thresholdsDashed: false,
                    maxThresholds: 5,
                    labelTextFormat: 'clamp',
                    labelLineClamp: true,
                    labelLineClampValue: 1,
                    labelWrapText: false,
                    endianTime: 'MMM DD YYYY',
                    blacklist: [],
                    centerAxis: {
                        enabled: true,
                        color: '',
                        size: 10,
                        spacing: 15,
                    },
                    smartSize: {
                        enabled: false,
                        mode: 'responsive',
                        size: 'm',
                        baseline: {
                            spacing: 6,
                            padding: 21,
                            labelSize: 50,
                            metricValueSize: 50,
                            metricPercentChangeSize: 17,
                            metricNameSize: 15,
                        },
                        optionDefaults: {
                            labelEnable: false,
                            showMetricName: true,
                            showMetricValue: true,
                            showMetricChange: false,
                            showTimeRemainder: true,
                        },
                        breakpoints: {
                            xs: {
                                options: {
                                    labelEnable: false,
                                    showMetricName: false,
                                    showMetricValue: false,
                                    showMetricChange: false,
                                    showTimeRemainder: false,
                                },
                            },
                            s: {
                                options: {
                                    showMetricName: false,
                                    showMetricChange: false,
                                    showTimeRemainder: false,
                                },
                            },
                            m: {
                                options: {
                                    showMetricChange: false,
                                    showTimeRemainder: false,
                                },
                            },
                        },
                    },
                    percentChangeColor: {
                        enabled: false,
                        up: '#33CC99',
                        zero: '',
                        down: '#FF6060',
                    },
                    orientation: 'vertical',
                    showSentiment: false,
                    portrait: {
                        widgetOrientation: 'portrait',
                        limit: 6,
                        metricNameSize: 20,
                        labelSize: 50,
                    },
                },
                globalDataSourceName: null,
                useGlobalDataSources: false,
                theme,
                userAssetId: null,
                userAssetContentUrl: null,
                classes: null,
                css: null,
                js: null,
                postRequests: null,
                profileRequests: null,
                trendRequests: null,
                children: null,
                useGlobalPreviousTimePeriod: null,
            },
        ],
        id: 'wbz4kz3u2',
        name: null,
        type: null,
        useGlobalTimePeriod: true,
        css: `

        .widget_single_metric .single_metric {
            align-items: flex-start!important;
        }

        .widget_single_metric .widget_inner {
            margin-top: 1em;
        }

        /*
        .widget_trend_over_time .bar_chart {
            top: -1em;
        }

        .widget_trend_over_time .bar_chart .meta_group {
            justify-content: flex-end;
            padding: 0;
        }

        .widget_trend_over_time .bar_chart .bar_name {
            transform: translate3d(0, 1.25em, 0)
        }

        .widget_trend_over_time .bar_chart_inner.horizontal .metric {
            margin-top: auto;
        }
        */

        /*  label spacing */
        .widget_label {
            margin-bottom: -.75em;
            // opacity: .6;
            // border-bottom: 1px solid white;
            // padding-bottom: 0.25em;
        }

        /* Table */

        .widget .ranked_table {
            justify-content: flex-start!important;
            gap: .75em;
        }

        .widget .ranked_table .row_key {
            display: none;
        }

        .widget .ranked_table .cell {
            padding: 0;
        }

        .widget .ranked_table .row .cell:nth-child(3) {
            display: none;
        }

        .widget .ranked_table .metric_name {
            line-height: 0.75;
        }

        /* Post Group */

        .widget_grid.widget .post_group {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: .33em;
        }

        .widget_grid.widget .post {
            position: relative;
            width: auto!important;
            height: 100%!important;
            left: initial!important;
            top: initial!important;
        }

        .widget_grid.widget .post {
            font-size: 1em!important;
        }

        .widget_grid.widget .post > div {
            border-radius: 0.5em!important;
        }

        .widget_grid.widget .post_container_native_post {
            background-color: transparent;
        }

        /* gross and brittle */
        .widget_grid .post_type_instagram > div > div:nth-child(2) {
            height: 40%;
        }

        /* Profile stuff */
        .profile_description {
            display: none;
        }

        .profile_group.post_group {
            gap: 0.5em;
            display: flex;
            flex-direction: column;
        }

        .widget .profile {
            position: relative;
            display: block;
            left: auto;
            top: auto;
            width: 100%;
            height: auto;
            padding: 0 0 0 .5em;
        }

        .widget .profile .metric_name {
            margin: 0;
        }

        .widget .profile .user_screen_name {
            margin-top: -.3em;
        }

        .widget .profile .metric .group {
            align-items: flex-end;
        }

        .widget .profile .profile_metrics {
            padding: .4em 0 0 0;
        }

        .widget .profile_info {
            padding: 0 0 0 .75em;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        .widget .profile_lockup {
            font-size: 1.5em;
        }

        /* top countries and cities */
        .widget_id_drilldown_top_countries_cities .bar_name {
            text-transform: capitalize;
        }

        /* wedge */
        .wedge_ratio {
            font-size: 20px;
        }

        .profile.verified .user_full_name:after {
            position: absolute;
             /* no size or position settings */
            background: url(https://upload.wikimedia.org/wikipedia/commons/e/e4/Twitter_Verified_Badge.svg) no-repeat;
            width: 1em;
            height: 1em;
            margin-left: .15em;
            content: "";
        }

        .native_post > div {
            height: 100%;
        }
        `,
        js: null,
        options: {
            player: {
                playing: false,
                duration: 15,
            },
            labelEnable: true,
            labelTimeRangeSize: 16,
            labelTimeRangeEnabled: false,
            labelTimeRangeFormat: 'Pretty Time',
            labelTimeZone: '',
            animationLength: 1000,
            animationDelay: 0,
            animationType: 'fade',
            animationEnabled: false,
            animationVariation: 6,
            widgetOrientation: 'landscape',
            opacity: 100,
            zIndex: 0,
            locked: false,
            sort: 'auto',
            percentChangeFormat: '1k',
            metricTimeRoundSeconds: false,
            fontFamilySecondary: null,
            fontFamilyPrimary: null,
            fontSize: null,
            colorFont: null,
            showSocialColors: true,
            metricThreshold: null,
            showFullTimePeriod: false,
            textFormat: '',
            useThemeColor: false,
            useThemeImage: false,
            useThemeEmail: false,
            themeEmailSize: 20,
            themeImagePosition: null,
            themeImageOpacity: 100,
            themeImageCircleMask: true,
            themeImageSize: 100,
            barChartScale: 100,
            showPostTextOverlayAsGradient: false,
            classOverrides: {},
            postVersion: 1,
            zeroFill: false,
            zeroKill: false,
            autoSizeWords: false,
            invertDataSet: false,
            showAdsMetrics: false,
        },
        userAssetContentUrl: null,
        postRequests: null,
        classes: 'template_custom',
        theme: {
            ...theme,
            ext: { ...new ExtImpl(), padding: 20, grid: { ...new ExtImpl().grid, gap: 40 } },
        },
        position: {
            left: '0',
            right: null,
            top: '0',
            bottom: null,
            width: '100%',
            height: '100%',
            portrait: null,
            landscape: null,
            backgroundColor: null,
            display: null,
            maxWidth: null,
            maxHeight: null,
        },
        analyticsRequests: null,
        analyticsResults: null,
        profileRequests: null,
        profileResults: null,
        trendRequests: null,
        label: {
            titleText: 'Panel',
            subTitleText: null,
            classes: null,
            overlap: false,
            layout: 'flex no-grow vertical left',
            icon: null,
            enabled: false,
            size: 20,
        },
    },
    screenIndex: 0,
    sceneIndex: 1,
    dataLastModified: 1578517370516,
};

export default ListeningTemplate;
